//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { UploadCoverImageResult } from '@apis/universal-posts/cover-image/universalPostsCoverImageApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const COVER_IMAGE_DEFAULT_ENDPOINT = '/api/v1/cover-image';

const universalPostsCoverImageFetch = (
  endpoint: string,
  init?: RequestInit,
  useFetchHeader?: boolean,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'universal_scheduling_gateway',
    `${COVER_IMAGE_DEFAULT_ENDPOINT}${endpoint}`,
    init,
    useFetchHeader,
  );
};

/**
 * Uploads a cover image for a post
 *
 * POST /api/v1/cover-image
 */
export const uploadCoverImage = async (
  file: File,
  init?: RequestInit,
): Promise<UploadCoverImageResult> => {
  const formData = new FormData();
  formData.append('coverImage', file, file.name);

  const res = await universalPostsCoverImageFetch(
    '',
    {
      ...init,
      method: 'POST',
      body: formData,
    },
    true,
  );

  return (await res.json<{ data: UploadCoverImageResult }>()).data;
};
